/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_Task_ScopeInputs */

const cs_settings_prefs_task_scope = /** @type {(inputs: Settings_Prefs_Task_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí rozsah úkolů`)
};

const en_settings_prefs_task_scope = /** @type {(inputs: Settings_Prefs_Task_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default task list scope`)
};

/**
* | output |
* | --- |
* | "Default task list scope" |
*
* @param {Settings_Prefs_Task_ScopeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_task_scope = /** @type {((inputs?: Settings_Prefs_Task_ScopeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_Task_ScopeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_task_scope(inputs)
	return cs_settings_prefs_task_scope(inputs)
});